import React from "react";
import styles from '../css/TargetLimitBox.module.css'
import Toggle from '../../../globalcomponents/Toggle'
import Select from 'react-select'
import { Tooltip } from 'antd';

function TargetLimitBox(props) {
    let data = props.data[props.dataKey]
    let allTargetTypes = Object.keys(props.data);
    const sym = props.limitType === 'static' ? '#' : '%';

    const possibleTargetChanges = [];
    const permittedTargetChanges = [];

    allTargetTypes.map(target => {
        possibleTargetChanges.push({ label: target, value: target })
    })

    data.permittedTargetChanges.map(target => {
        permittedTargetChanges.push({ label: target, value: target })
    })
//https://github.com/hc-oss/react-multi-select-component#readme
    return (
        <div className={styles.targetLimitGrid}>
            <label className={styles.targetLimitBoxLabel}>{props.dataKey}</label>
            <div className={styles.targetLimitBoxAllowChanges}>
                <Tooltip title="Allow Changes prevents the user modifying the CHANGED TARGET VALUE dropdown for this target type.">
                    <div className={styles.inputTitle}>Allow Changes</div>
                </Tooltip>
                <Toggle active={data.allowChanges} click={() => {
                        props.setData({
                            ...props.data,
                            [props.dataKey]: {
                                ...data,
                                allowChanges: !data.allowChanges
                            }
                        })
                }}/>
            </div>
            <div className={styles.set}>
                <Tooltip title="Permitted Targets sets the target values that the user can select in the CHANGED TARGET VALUE dropdown FROM this target type.">
                    <div className={styles.inputTitle}>Permitted Targets <div className={styles.required}>*</div></div>
                </Tooltip>
                <Select
                    defaultValue={permittedTargetChanges}
                    isMulti
                    name="permitted-target-changes"
                    options={possibleTargetChanges}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    onChange={(newValue) => {
                        // react-select 5 always passes an array for isMulti (empty after the
                        // last chip is removed or the field is cleared), so every action persists.
                        props.setData({
                            ...props.data,
                            [props.dataKey]: {
                                ...data,
                                permittedTargetChanges: newValue.map(values => values.value)
                            }
                        })
                    }}
                />
            </div>
            <div className={styles.inputPair}>
                <div className={styles.set}>
                    <div className={styles.inputTitle}>MAX {sym} RECLASSIFY</div>
                    <input type="number" min="0" value={data.maxChanges} onChange={(event) => {
                            props.setData({
                                ...props.data,
                                [props.dataKey]: {
                                    ...data,
                                    maxChanges: event.target.value
                                }
                            })
                        }} />
                </div>
                <div className={styles.set}>
                    <div className={styles.inputTitle}>MIN {sym} TO RETAIN</div>
                    <input type="number" min="0" value={data.minRequired} onChange={(event) => {
                            props.setData({
                                ...props.data,
                                [props.dataKey]: {
                                    ...data,
                                    minRequired: event.target.value
                                }
                            })
                        }} />
                </div>
            </div>
            <div className={styles.inputPair}>
                <div className={styles.set}>
                    <div className={styles.inputTitle}>MAX {sym} CALLS 🢁</div>
                    <input type="number" min="0" value={data.maxCalls} onChange={(event) => {
                            props.setData({
                                ...props.data,
                                [props.dataKey]: {
                                    ...data,
                                    maxCalls: event.target.value
                                }
                            })
                        }} />
                </div>
                <div className={styles.set}>
                    <div className={styles.inputTitle}>MIN {sym} CALLS 🢃</div>
                    <input type="number" min="0" value={data.minCalls} onChange={(event) => {
                            props.setData({
                                ...props.data,
                                [props.dataKey]: {
                                    ...data,
                                    minCalls: event.target.value
                            }
                        })
                    }} />
                </div>
            </div>
            <div className={styles.inputPair}>
                <div className={styles.set}>
                    <div className={styles.inputTitle}>MAX {sym} UPGRADE 🢁</div>
                    <input type="number" min="0" value={data.maxUpgrades ?? 0} onChange={(event) => {
                            props.setData({
                                ...props.data,
                                [props.dataKey]: {
                                    ...data,
                                    maxUpgrades: event.target.value
                                }
                            })
                        }} />
                </div>
                <div className={styles.set}>
                    <div className={styles.inputTitle}>MAX {sym} DOWNGRADE 🢃</div>
                    <input type="number" min="0" value={data.maxDowngrades ?? 0} onChange={(event) => {
                            props.setData({
                                ...props.data,
                                [props.dataKey]: {
                                    ...data,
                                    maxDowngrades: event.target.value
                                }
                            })
                        }} />
                </div>
            </div>
        </div>
    )
}

export default TargetLimitBox
